import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: '대면 ID 및 서명 필요',
      description_1: '처방약은 지정된 환자에게만 전달됩니다. 수령인의 신분증과 서명이 모두 필요하며, 신분증의 이름은 수령인과 일치해야 합니다.',
      description_2: '배달 기사는 환자의 신분증과 현관 사진을 찍습니다.',
    },
    'face-2-face-not-required': {
      label: '대면 서명 불필요',
      description: '환자와 함께 거주하는 18세 이상의 성인의 서명이 필요합니다. 배달 기사는 환자의 현관 사진을 찍습니다.',
    },
    'face-2-face-required': {
      label: '대면 서명 필요',
      description: '환자와 함께 거주하는 사람의 서명이 필요합니다. 배달 기사는 환자의 현관 사진을 찍습니다.',
    },
    'non-contract-delivery': {
      label: '비대면 배달',
      description: '배달 기사는 대면 없이 문 앞에 약을 놓고 사진을 찍습니다.',
    },
    'online-signature': {
      label: '온라인 서명',
      description_1: '배달 기사는 처방약을 문 앞에 놓고 사진을 찍습니다. 단,',
      description_2: '수령인이 배달 전 온라인 서명을 완료한 경우에만 가능합니다. 온라인 서명이 없으면,',
      description_3: '배달 방식은 "대면 서명 필요"로 진행됩니다.',
    },
    'signature-optional': {
      label: '서명 선택 사항',
      description: '배달 기사는 대면 배달을 시도합니다. 부재 시, 문 앞에 약을 놓고 사진을 찍습니다.',
    },
  },
  tips,
  copay,
  delivery,
  wait: '잠시만 기다려 주세요...',
  'promised-eta': '예상 도착 시간:',
  reschedule: '재예약/주소 변경',
  dates: {
    today: '오늘',
    tomorrow: '내일',
    'today-at': '오늘 {time}',
    'date-at': '{date} {time}',
    'before-time': '{time} 이전',
    'time-until': '{from} - {time}',
    'time-from': '{time} - {to}',
    apt: '호',
    'delivery-unavailable': '배송일을 확인할 수 없습니다',
  },
  payment: {
    error: '오류',
    success: '성공',
    'transaction-error': '결제 오류: {message}',
    okay: '확인',
    'copay-success': '본인 부담금이 결제되었습니다',
    'success-bang': '성공!',
  },
  role: {
    driver: '기사',
    dispatcher: '배차원',
  },
  'address-check': {
    title: '주소가 변경되었습니다',
    entered: '입력한 주소:',
    validated: '확인된 주소:',
    accept: '변경 적용',
    keep: '내 주소가 맞습니다',
    cancel: '취소',
  },
  push: {
    title: '푸시 알림 켜기',
    message: '브라우저 알림으로 배송 상태를 바로 받아 보세요.',
  },
}
